export default "__VITE_ASSET__Ds0fGD85__"